var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroq({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 8,
    fill: "#F55036"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 75,
    fontFamily: "Arial, sans-serif",
    fontSize: 70,
    fontWeight: 400,
    fill: "white",
    textAnchor: "middle"
  }, "g")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroq);
export default __webpack_public_path__ + "static/media/groq.e7edd2546e954eb8c077a4a7918b5b6e.svg";
export { ForwardRef as ReactComponent };